import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {PhoneCountryInfo} from "../../../models/phone-country-info";
import {OrderService} from "../../services/order.service";
import {PHONE_MASK} from "../../../helpers/format-helpers";

@Component({
  selector: "app-referral",
  templateUrl: "./referral.component.html",
  styleUrls: ["./referral.component.css"]
})
export class ReferralComponent implements OnInit {
  displaySuccess = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
  ) {
  }

  private referralCode: string | null;
  countryCodes: any;
  phoneNumber = "";
  isLoading = false;

  isIOS: boolean;
  isAndroid: boolean;

  phoneMask = PHONE_MASK;


  ngOnInit(): void {
    this.referralCode = this.route.snapshot.queryParamMap.get("r");

    this.countryCodes = [
      {country: "AT", prefix: 43} as PhoneCountryInfo,
      {country: "DE", prefix: 49} as PhoneCountryInfo,
      {country: "GB", prefix: 44} as PhoneCountryInfo,
    ];

  }

  checkDevice(): void {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.isIOS = true;
      this.redirectToAppStore();
    }
    // Check if Android
    else if (/android/i.test(userAgent)) {
      this.isAndroid = true;
      this.redirectToPlayStore();
    }
    // Other devices
    else {

    }
  }

  redirectToAppStore(): void {
    window.location.href = "https://apps.apple.com/de/app/king/id1577565747";
  }

  redirectToPlayStore(): void {
    window.location.href = "https://play.google.com/store/apps/details?id=com.cardcompact.app";
  }

  redirectToGetApp(): void {
    window.location.href = "https://cardbro.cardcompact.com/app";
  }


  submitPhone(): void {

    this.isLoading = true;

    if (!this.phoneNumber) {
      return;
    }
    if (this.phoneNumber.startsWith("00")) {
      this.phoneNumber = this.phoneNumber.substr(2);
    }

    this.orderService.acceptReferral(
      this.referralCode,
      this.phoneNumber,
    ).subscribe(res => {

      if (res.status == 0) {
        // ok

        if (this.isIOS) {
          this.redirectToAppStore();
        } else if (this.isAndroid) {
          this.redirectToPlayStore();
        } else {
          this.redirectToGetApp();
        }

      } else {
        alert("Fehler: " + res.message);
      }

    });
  }


  protected readonly PHONE_MASK = PHONE_MASK;
}
